module.exports = __webpack_public_path__ + "static/scenario4-083e3a93b5bc252ef1483dec70700a11.png";